// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '@/store/auth/authSlice';
import { refreshAccessToken } from '@/store/auth/authThunks';

const REFRESH_MAGIN_MS = 60 * 1000; // Refreshataan token minuutti ennen vanhenemista

/**
 * Hallinnoi tokenin elinkaarta (päivittäminen ja uloskirjautuminen).
 */
export const useAuthTokenManager = () => {
  const dispatch = useDispatch();
  const { token, refreshToken, expiresAt } = useSelector(state => state.auth);

  useEffect(() => {
    if (!token || !refreshToken || !expiresAt) return;

    const now = Date.now();
    const timeUntilRefresh = expiresAt - now - REFRESH_MAGIN_MS;

    if (timeUntilRefresh <= 0) {
      dispatch(refreshAccessToken(refreshToken))
        .unwrap()
        .catch(() => {
          dispatch(logout());
        });

      return;
    }

    const timerId = setTimeout(() => {
      dispatch(refreshAccessToken(refreshToken))
        .unwrap()
        .catch(() => {
          dispatch(logout());
        });
    }, timeUntilRefresh);

    return () => clearTimeout(timerId);
  }, [token, refreshToken, expiresAt, dispatch]);
};
